import { gql } from '@apollo/client';

export default gql`
  mutation UpdateAnalyse($input: UpdateAnalyseInput!) {
    updateAnalyse(input: $input) {
      __typename
      ... on Result {
        ID
        CEC
        analyseID
        organicMatter
        phWater
        phKcl
        summaryCalcium
        summaryMagnesium
        summaryPotassium
        summarySodium
        summaryHydrogen
        summaryOther
        perfectRatioCalcium
        perfectRatioMagnesium
        calciumReal
        magnesiumReal
        potassiumReal
        sodiumReal
        phosphorusReal
        boronReal
        ironReal
        manganeseReal
        copperReal
        zincReal
        calciumIdeal
        magnesiumIdeal
        potassiumIdeal
        sodiumIdeal
        phosphorusIdeal
        boronIdeal
        ironIdeal
        manganeseIdeal
        copperIdeal
        zincIdeal
        Products {
          name
          max
          years
        }
      }
    }
  }
`;
